import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar.js';
import Sidebar from '../components/Sidebar.js';
import { useNavigate } from "react-router-dom";
import { Globals } from '../globalfunctions.js';
import { SUPPORTED_CURRENCIES, DEFAULT_CURRENCY, formatMoney } from '../utils/currency';
import { hostnameFromLine, isDomainProductType, tldFromProductName } from '../utils/siteHostname';
import { apiClient } from '../utils/apiClient';
import { alertDialog } from '../utils/dialogs';
import './AddInvoice.css'; // Import the CSS file for styling

// UK VAT. Staff can zero this per invoice for non-taxed/export work.
const DEFAULT_TAX_RATE = 20;

function AddInvoice() {
  
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    customer: [],
    dueDate: '',
    status: 'Draft',
    tax_rate: DEFAULT_TAX_RATE,
    currency: DEFAULT_CURRENCY,
    purchaseditem: []
  });

  const [customers, setCustomers] = useState([]); // Example customer list
  const [filteredCustomers, setFilteredCustomers] = useState(customers);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const data = await apiClient.post('/api/users/findall');
        const customerList = data.map(customer => ({
          id: parseInt(customer.id),
          first_name: customer.first_name,
          last_name: customer.last_name,
          email: customer.email
        }))
        setCustomers(customerList);
        setFilteredCustomers(customerList);
      } catch (error) {
        console.error('Error fetching customers:', error);
      }
    };

    fetchCustomers();
  }, []);
  


  const [purchasedItems, setPurchasedItems] = useState([]); // Example customer list
  const [filteredPurchasedItems, setFilteredPurchasedItems] = useState(purchasedItems);

  useEffect(() => {
    const fetchCPurchasedItems = async () => {
      try {
        const data = await apiClient.get('/api/PurchasableItems');
        const PurchasedItemsList = data.map(purchaseditem => ({
          key: parseInt(purchaseditem.id),
          product_id: parseInt(purchaseditem.id),
          item_name: purchaseditem.item_name,
          item_description: purchaseditem.item_description,
          product_type: purchaseditem.item_type,
          product_category_id: parseInt(purchaseditem.item_category_id),
          line_item_cost: purchaseditem.item_cost,
          line_item_full_price: purchaseditem.item_price,
          item_discount: 0,
          line_item_profit: purchaseditem.item_price - purchaseditem.item_cost,
          userID: "",
          remarks: ''
        }));
        setPurchasedItems(PurchasedItemsList);
        setFilteredPurchasedItems(PurchasedItemsList);
      } catch (error) {
        console.error('Error fetching customers:', error);
      }
    };

    fetchCPurchasedItems();
  }, []);


  useEffect(() => {
    if (Globals.LoginTime === null) {
      navigate('/login');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Mirrors calculateTotals() on the API - shown so staff see the tax
  // breakdown before submitting, but the API recomputes it on save
  // rather than trusting these numbers from the client.
  const invoiceTotals = (() => {
    const subtotal = formData.purchaseditem.reduce(
      (sum, item) => sum + (parseFloat(item.line_item_full_price) || 0) - (parseFloat(item.item_discount) || 0),
      0
    );
    const taxRate = parseFloat(formData.tax_rate) || 0;
    const taxAmount = Math.round(subtotal * (taxRate / 100) * 100) / 100;
    return { subtotal, taxRate, taxAmount, total: Math.round((subtotal + taxAmount) * 100) / 100 };
  })();

  const handleCustomerSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setFilteredCustomers(customers.filter(customer => customer.toLowerCase().includes(searchValue)));
  };

  const handleCustomerSelect = (customer) => {
    if (customer === "New Customer") {
      navigate('/createcustomer'); // Navigate to the home page if "New Customer" is selected
    } else {
      console.log('Selected customer:', customer);
      setFormData({ ...formData, customer });
      setFilteredCustomers([]); // Hide the list after selecting a customer
    }
  };

  const handlePurchasedItemSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setFilteredPurchasedItems(
      purchasedItems.filter(purchaseditem =>
        purchaseditem.item_name.toLowerCase().includes(searchValue) ||
        purchaseditem.item_description.toLowerCase().includes(searchValue)
      )
    );
  };

  const handlePurchasedItemSelect = (purchaseditem) => {
      setFormData({ ...formData, purchaseditem: [...formData.purchaseditem, purchaseditem] });

      setFilteredPurchasedItems([]); // Hide the list after selecting a customer
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const result = await apiClient.post('/api/purchases', formData);

      console.log('Invoice successfully created:', result);
        



        // Create the overlay
        const overlay = document.createElement('div');
        overlay.className = 'invoice-overlay';
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100vw';
        overlay.style.height = '100vh';
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        overlay.style.display = 'flex';
        overlay.style.justifyContent = 'center';
        overlay.style.alignItems = 'center';
        overlay.style.zIndex = '1000';
  
        // Create the overlay content container
        const overlayContent = document.createElement('div');
        overlayContent.className = 'overlay-content';
        overlayContent.style.backgroundColor = '#fff';
        overlayContent.style.padding = '20px';
        overlayContent.style.borderRadius = '8px';
        overlayContent.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
        overlayContent.style.width = '70%';
        overlayContent.style.height = '70%';
        overlayContent.style.maxHeight = '80%';
        overlayContent.style.overflowY = 'auto';
  

        
        const ButtonContent = document.createElement('div');
        ButtonContent.style.textAlign = 'center';

                // Create the "Approve" button
        const approveButton = document.createElement('button');
        approveButton.textContent = 'Approve Invoice';
        approveButton.style.margin = '10px';
        approveButton.style.padding = '10px 20px';
        approveButton.style.backgroundColor = '#28a745';
        approveButton.style.color = '#fff';
        approveButton.style.border = 'none';
        approveButton.style.borderRadius = '4px';
        approveButton.style.cursor = 'pointer';
        approveButton.onclick = async () => {
          try {
            console.log('Updating payment status...');
            const result2 = await apiClient.post('/api/invoices/UpdateInvoiceStatus', {
              invoice_number: result.invoice_number,
              payment_status: "Pending Payment",
            });
            console.log('Payment status updated successfully:', result2);
          } catch (error) {
            console.error('Error updating payment status:', error);
            alertDialog(error.message ? `Error: ${error.message}` : 'An error occurred while updating the payment status. Please try again.');
          }
            document.body.removeChild(overlay); // Remove the overlay when closed
            navigate('/invoices'); // Navigate back to the invoices page
          };
        ButtonContent.appendChild(approveButton);

        
        // Create the "Approve" button
        const draftButton = document.createElement('button');
        draftButton.textContent = 'Draft Invoice';
        draftButton.style.margin = '10px';
        draftButton.style.padding = '10px 20px';
        draftButton.style.backgroundColor = '#FFBF00';
        draftButton.style.color = '#fff';
        draftButton.style.border = 'none';
        draftButton.style.borderRadius = '4px';
        draftButton.style.cursor = 'pointer';
        draftButton.onclick = async () => {
            document.body.removeChild(overlay); // Remove the overlay when closed
            navigate('/invoices'); // Navigate back to the invoices page
          };
        ButtonContent.appendChild(draftButton);
  
        // Create the "Close" button
        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel Invoice';
        cancelButton.style.margin = '10px';
        cancelButton.style.padding = '10px 20px';
        cancelButton.style.backgroundColor = '#dc3545';
        cancelButton.style.color = '#fff';
        cancelButton.style.border = 'none';
        cancelButton.style.borderRadius = '4px';
        cancelButton.style.cursor = 'pointer';
        cancelButton.onclick = async () => {
          try {
            console.log('Updating payment status...');
            const result2 = await apiClient.post('/api/invoices/DeleteInvoice', {
              invoice_number: result.invoice_number
            });
            console.log('Payment status updated successfully:', result2);
          } catch (error) {
            console.error('Error updating payment status:', error);
            alertDialog(error.message ? `Error: ${error.message}` : 'An error occurred while updating the payment status. Please try again.');
          }
          document.body.removeChild(overlay); // Remove the overlay when closed
          };
        ButtonContent.appendChild(cancelButton);

        overlayContent.appendChild(ButtonContent);
        // Fetch and display the PDF
        try {
          await new Promise(resolve => setTimeout(resolve, 500)); // Delay for 500ms
          console.log('Fetching PDF for invoice number:', result.invoice_number);
          console.log(result);
          const pdfResponse = await apiClient.post('/api/invoices/DisplayInvoice', { invoiceNum: result.invoice_number }, { raw: true });
          console.log('PDF response status:', pdfResponse.status);
  
          if (pdfResponse.ok) {
            const blob = await pdfResponse.blob();
            console.log('PDF blob:', blob);
            console.log('PDF blob:', blob.size, 'bytes');
            const url = window.URL.createObjectURL(blob);
            const iframe = document.createElement('iframe');
            iframe.src = url;
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
  
            /*iframe.onload = () => {
              try {
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                const sidenavContainer = iframeDocument.querySelector('.sidenav-container');
                if (sidenavContainer) {
                  sidenavContainer.style.width = '0px'; // Set the width to 0px
                  sidenavContainer.style.visibility = 'hidden'; // Hide the sidenav
                }
              } catch (error) {
                console.error('Error accessing iframe content:', error);
              }
            };*/
            // Display the PDF in the overlay
            overlayContent.appendChild(iframe);
          } else {
            console.error('Failed to fetch PDF');
            const errorMessage = document.createElement('p');
            errorMessage.textContent = 'Failed to load the PDF.';
            overlayContent.appendChild(errorMessage);
          }
        } catch (error) {
          console.error('Error fetching PDF:', error);
          const errorMessage = document.createElement('p');
          errorMessage.textContent = 'An error occurred while loading the PDF.';
          overlayContent.appendChild(errorMessage);
        }
  
        // Append the content to the overlay
        overlay.appendChild(overlayContent);
  
        // Append the overlay to the body
        document.body.appendChild(overlay);
  
        //alertDialog('Invoice successfully created!');
    } catch (error) {
      console.error('Error submitting form:', error);
      alertDialog(error.message ? `Error: ${error.message}` : 'An error occurred while submitting the form. Please try again.');
    }
  };

  return (
    <div>
      <Navbar />
      <Sidebar />
      <br />
      <div className='main-content'>
        <h1 className="form-title">Create Invoice</h1>
        <form onSubmit={handleSubmit} className="invoice-form">
        <div className="form-group">
          <label htmlFor="customerSearch">Search Customer:</label>
          <input
            type="text"
            id="customerSearch"
            placeholder="Search for a customer"
            onChange={handleCustomerSearch}
            onFocus={() => setFilteredCustomers(customers)} // Reset the filtered list on focus
          />
          {/* Show the customer list only if there are filtered results */}
          {filteredCustomers.length > 0 && (
            <ul className="customer-list">
              <li key="new-customer" style={{ backgroundColor: 'lightgreen' }}
                onClick={() => handleCustomerSelect("New Customer")}
                className="customer-item">New Customer</li>
              {filteredCustomers.map((customer, index) => (
                <li
                  key={customer.id}
                  onClick={() => handleCustomerSelect(customer)}
                  className="customer-item"
                >
                  {customer.first_name} {customer.last_name} - {customer.email}
                </li>
              ))}
              {/* Add "New Customer" option */}
            </ul>
          )}
          {/* Display the selected customer */}
          {formData.customer && (
            <div className="selected-customer">
              <strong>Selected Customer:</strong> {formData.customer.first_name} {formData.customer.last_name} - {formData.customer.email}
            </div>
          )}
        </div>
          <div className="form-group">
            <label htmlFor="dueDate">Due Date:</label>
            <input
              type="date"
              id="dueDate"
              name="dueDate"
              value={formData.dueDate}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="currency">Currency:</label>
            <select id="currency" name="currency" value={formData.currency} onChange={handleChange}>
              {Object.keys(SUPPORTED_CURRENCIES).map((code) => (
                <option key={code} value={code}>{code} ({SUPPORTED_CURRENCIES[code].symbol})</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="tax_rate">VAT / Tax Rate (%):</label>
            <input
              type="number"
              id="tax_rate"
              name="tax_rate"
              min="0"
              max="100"
              step="0.01"
              value={formData.tax_rate}
              onChange={handleChange}
            />
          </div>
          {/*
          <div className="form-group">
            <label htmlFor="status">Invoice Status:</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="">Select Status</option>
              <option value="Draft">Draft</option>
              <option value="Pending">Payment Pending</option>
              <option value="Overdue">Overdue</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>*/}
          <div className="form-group">
          <label htmlFor="purchasedItemSearch">Add purchased item:</label>
          <input
            type="text"
            id="purchasedItemSearch"
            placeholder="Search for a purchased item"
            onChange={handlePurchasedItemSearch}
            onFocus={() => setFilteredPurchasedItems(purchasedItems)} // Reset the filtered list on focus
          />
          {/* Show the purchased item list only if there are filtered results */}
          {filteredPurchasedItems.length > 0 && (
            <ul className="purchaseditem-list">
              {filteredPurchasedItems.map((purchaseditem, index) => (
                <li
                  key={index}
                  onClick={() => handlePurchasedItemSelect(purchaseditem)}
                  className="purchaseditem-item"
                >
                  {`${purchaseditem.product_type} ${purchaseditem.item_name} - ${purchaseditem.item_description} - £${purchaseditem.line_item_full_price}`}
                </li>
              ))}
            </ul>
          )}
          {/* Display the selected purchased items */}
          {formData.purchaseditem.length > 0 && (
              <div className="selected-purchaseditem">

              {/* Display the selected purchased items in a table */}
{formData.purchaseditem.length > 0 && (
  <div className="purchaseditem-table-container">
    <h3>Selected Purchased Items</h3>
    <table className="purchaseditem-table">
      <thead>
        <tr>
          <th>Item type</th>
          <th>Name</th>
          <th>Description</th>
          <th>Cost</th>
          <th>Full price</th>
          <th>Discount (%)</th> {/* New column for discount */}
          <th>Line Item Price</th>
          <th>Profit/Loss</th>
          <th>Remarks (As shown on invoice)</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
  {formData.purchaseditem.map((item, index) => (
    <tr key={index}>
      <td>{item.product_type}</td>
      <td>{item.item_name}</td>
      <td>{item.item_description}</td>
      <td>{`£${item.line_item_cost}`}</td>
      <td>{`£${item.line_item_full_price}`}</td>
      <td>
        <input
          type="number"
          min="0"
          max="100"
          value={item.discountpercentage || 0} // Default to 0 if no discount is set
          onChange={(e) => {
            const updatedItems = [...formData.purchaseditem];
            updatedItems[index] = {
              ...updatedItems[index],
              discountpercentage: e.target.value, // Update the discount for the current item
              item_discount: (item.line_item_full_price * ((e.target.value || 0) / 100)).toFixed(2),
              line_item_profit: ((item.line_item_full_price - ((item.line_item_full_price * ((e.target.value || 0) / 100)).toFixed(2))).toFixed(2) - item.line_item_cost).toFixed(2)
            };
            setFormData({ ...formData, purchaseditem: updatedItems });
          }}
          className="discount-input"
        />
      </td>
      <td>{(item.line_item_full_price - item.item_discount).toFixed(2)}</td>
      <td>{((item.line_item_full_price - item.item_discount).toFixed(2) - item.line_item_cost).toFixed(2)}</td>
      <td>
        {/* On a domain line the catalog item name IS the suffix (".co.uk"),
            so only the site name is typed here and the two are joined.
            The line underneath is what the outage tracker will watch, so a
            remark that can't be read as a site is obvious while it's being
            written rather than weeks later. */}
        <div className="remarks-cell">
          <div className="remarks-input-group">
            <input
              type="text"
              value={item.remarks || ''}
              onChange={(e) => {
                const updatedItems = [...formData.purchaseditem];
                updatedItems[index] = {
                  ...updatedItems[index],
                  remarks: e.target.value,
                };
                setFormData({ ...formData, purchaseditem: updatedItems });
              }}
              className="remarks-input"
              placeholder={isDomainProductType(item.product_type) ? 'belveder' : 'Enter remarks'}
            />
            {tldFromProductName(item.item_name) && (
              <span className="remarks-tld">{item.item_name}</span>
            )}
          </div>
          {(() => {
            const tracked = hostnameFromLine(item);
            if (tracked) return <span className="remarks-ok">Tracked as {tracked}</span>;
            if (isDomainProductType(item.product_type)) {
              return <span className="remarks-warn">Not trackable — put the site name here</span>;
            }
            return null;
          })()}
        </div>
      </td>
      <td>


        <button
        type="button" // Prevents the button from acting as a submit button
        onClick={() => {
          const updatedItems = formData.purchaseditem.filter((_, i) => i !== index);
          setFormData({ ...formData, purchaseditem: updatedItems });
        }}
        className="remove-button"
      >
        Remove
      </button>
      </td>
    </tr>
  ))}
</tbody>
    </table>
    <div className="invoice-totals">
      <div><span>Subtotal</span><span>{formatMoney(invoiceTotals.subtotal, formData.currency)}</span></div>
      <div><span>VAT / Tax ({invoiceTotals.taxRate}%)</span><span>{formatMoney(invoiceTotals.taxAmount, formData.currency)}</span></div>
      <div className="invoice-totals-grand"><span>Total</span><span>{formatMoney(invoiceTotals.total, formData.currency)}</span></div>
    </div>
  </div>
)}
            </div>

          )}
          </div>
          <button type="submit" className="submit-button">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default AddInvoice;